// extracted by mini-css-extract-plugin
module.exports = {"auction-sale-container":"auction-sale_auction-sale-container__19D6P","active":"auction-sale_active__2kFxI"};